import { z } from 'zod';
import { DOCUMENT_TEMPLATE_KINDS } from '../enums.js';
import { optionalText, text } from './common.js';
export const documentTemplateKindSchema = z.enum(DOCUMENT_TEMPLATE_KINDS);
/**
 * Insert-only, per invariant 8's mechanism reused here for invariant 7's
 * content: publishing always creates a new version rather than mutating one
 * a generated Document may already point at (Document.documentTemplateId).
 *
 * `forwardingAddressClause` is required for, and only for, LEASE_AGREEMENT —
 * MCL 554.603(2)'s mandated warning clause has to exist before a lease
 * template can go live, and it has no meaning for any other kind.
 *
 * `body` is HTML from the staff rich-text editor (see RichTextEditor.tsx),
 * not plain text — the 50000 ceiling accounts for tag overhead: a single
 * merge-field chip span is ~95 characters to represent one ~25-character
 * token, so a realistic formatted template can run to roughly double its
 * plain-text equivalent's length.
 */
export const createDocumentTemplateSchema = z
    .object({
    kind: documentTemplateKindSchema,
    subject: optionalText(255),
    body: text(50000),
    forwardingAddressClause: optionalText(2000),
    isPublished: z.boolean().default(true),
})
    .refine((v) => v.kind !== 'LEASE_AGREEMENT' || !!v.forwardingAddressClause, {
    message: 'A lease agreement template requires the forwarding-address clause.',
    path: ['forwardingAddressClause'],
})
    .refine((v) => v.kind === 'LEASE_AGREEMENT' || !v.forwardingAddressClause, {
    message: 'The forwarding-address clause only applies to the lease agreement template.',
    path: ['forwardingAddressClause'],
});
//# sourceMappingURL=document-templates.js.map